import {
    Directive,
    ElementRef,
    inject,
    type AfterViewInit,
} from '@angular/core';

@Directive({
    selector: '[qpxAutofocus]',
})
export class Autofocus implements AfterViewInit {
    private readonly el = inject(ElementRef, { host: true });

    ngAfterViewInit() {
        this.el.nativeElement.focus();
    }
}
